/* eslint-disable @typescript-eslint/naming-convention */
import { environmentBase } from './environment.base';
import { IEnvironmentConfiguration } from '../environment.interface';
import { deepMerge } from '@ups/xplat/utils';

export const environmentStg = deepMerge(environmentBase, <
  IEnvironmentConfiguration
>{
  production: false,
  environment_name: 'stg',
  appsync: {
    production: true,
    android: {
      productionKey: process.env['AppSync:AndroidKey@prod'],
      stagingKey: process.env['AppSync:AndroidKey@stg'],
    },
    ios: {
      productionKey: process.env['AppSync:IosKey@prod'],
      stagingKey: process.env['AppSync:IosKey@stg'],
    },
    version: '0.0.1',
    serverUrl: process.env['Urls:AppSyncServerUrl'],
  },
  sockets: {
    signalR: {
      url: process.env['Urls:NotificationHub@stg'],
    },
  },
  name: 'safety',
  security: {
    allowEverything: false,
    securityOverride: false,
    securityOverrideJson: 'environments/security.json',
    apiUrl: process.env['Urls:SecurityApiAzure@stg'],
    appId: undefined,
  },
  urls: {
    azureAPI: process.env['Urls:AzureApi@stg'],
    sparta: process.env['Urls:Sparta@stg'],
    spartaAPI: process.env['Urls:SpartaApi@stg'],
    viewpointAPI: process.env['Urls:ViewpointApi@stg'],
    packetAPI: process.env['Urls:PacketApi@stg'],
    securityAPI: process.env['Urls:SecurityApi@stg'],
    softwareSecurityAPI: process.env['Urls:SoftwareSecurityApi@stg'],
    fileManagementAPI: process.env['Urls:FileManagementApi@stg'],
    tasksAPI: process.env['Urls:TasksApi@stg:Ups.Tasks.Api'],
    safetyAPI: process.env['Urls:SafetyApi@stg'],
    ratesAPI: process.env['Urls:RatesApi@stg'],
    toolTrackerAPI: process.env['Urls:ToolTrackerApi@stg'],
    reportsServer: process.env['Urls:ReportsServer@stg'],
    dynamicAPI: process.env['Urls:DynamicApi@stg'],
    myWeb: process.env['Urls:MyWeb@stg'],
    warehouseWeb: process.env['Urls:WarehouseWeb@stg'],
    spartaWeb: process.env['Urls:SpartaWeb@stg'],
    appStoreWeb: process.env['Urls:AppStoreWeb@stg'],
    resourceAllocationWeb: process.env['Urls:ResourceApplicationWeb@stg'],
    hseToolboxWeb: process.env['Urls:HseToolboxWeb@stg'],
    bridgeAPI: process.env['Urls:BridgeApi@stg'],
  },
  rynReplay: {
    // The unlabelled value is the prod player, which reads the prod read API and
    // so cannot open a stg session. Must stay set in App Config: deepMerge takes
    // an undefined override over the base value, so a missing key yields a
    // relative `/replay/<id>` link rather than falling back to prod.
    playerBaseUrl: process.env['RynReplay:PlayerBaseUrl@stg'],
  },
  host: process.env['Urls:HseToolBoxHostUrl@stg'],
  blobStorage: {
    url: process.env['Urls:AzureBlobStorageUrl@prod'],
    container: process.env['AzureBlobStorage:ContainerName@stg'],
  },
});
